import React from 'react'
import PlanCard from '../PlanCard'

type Props = {
  price: string
  total: string
  loading: boolean
  Pagar: ({ months, price, total, type }: any) => void
}

export const PaymentSemester = ({ price, total, loading, Pagar }: Props) => {
  return (
    <>
      <PlanCard
        title="Mais popular"
        price={price}
        cents={price}
        caption="Pagamento semestral"
        premium={true}
        description={[
          'Super promoção com 5% de',
          'desconto na compra de 6 meses!',
        ]}
        benefits={['Mais escolhido de todos', 'Garanta 6 meses de acesso']} //Super promoção com 5% de desconto na compra de 6 meses!
        value={`O valor de R$ ${total.replace('.', ',')}`}
        cardColor="#3EB9F2"
        buttonText={
          <div className="w-full h-full">
            {loading ? (
              <div className="flex   justify-center w-full h-full  ">
                <button
                  style={{ color: '#3EB9F2' }}
                  className="w-5/6 py-2 mt-2 font-semibold text-center bg-white rounded"
                >
                  Aguarde...
                </button>
              </div>
            ) : (
              <div className="flex   justify-center w-full h-full  ">
                <button
                  onClick={() =>
                    Pagar({
                      months: '6',
                      price: price,
                      total: total,
                      type: 'Pagamento mensalidade de 6 meses de acesso ao site igreja nas nuvens',
                    })
                  }
                  className="w-5/6 py-2 mt-2 font-semibold text-center bg-white border border-transparent rounded"
                  style={{ color: '#3EB9F2' }}
                >
                  Aproveitar a promoção
                </button>
              </div>
            )}
          </div>
        }
      />
    </>
  )
}
